import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@services';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerSfdcInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.kepler.sfdc.url;
    const authService = inject(AuthService);

    if (urlToMatch && req.url.startsWith(urlToMatch) && req.method !== 'OPTIONS') {
        const clone = cloneAndAddHeaders(req, {
            Authorization: `Bearer ${authService.accessToken}`,
            'csdt-authorization-app': csdtAuthApp,
            'Content-Type': 'application/json',
        });
        console.debug('[Interceptors][KeplerSfdcInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
